import './polyfill';

import * as Sentry from '@sentry/react';
import TelegramAnalytics from '@telegram-apps/analytics';
import { Assert } from '@team/assert';
import { TelegramKit } from '@team/telegram-kit';
import { retrieveLaunchParams } from '@telegram-apps/bridge';
import { store, sagaManager } from '@team/steps-core';
import { System } from 'core/system';
import { Perf } from 'core/perf';

if (!import.meta.env.DEV) {
  const isProd = import.meta.env.MODE === 'production';

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DNS,
    integrations: [],
    environment: import.meta.env.MODE,
    tracesSampleRate: isProd ? 0.2 : 1,
    sampleRate: isProd ? 0.1 : 1,
  });
}

if (import.meta.env.MODE === 'production') {
  void TelegramAnalytics.init({
    token: import.meta.env.VITE_TMA_ANALYTICS_TOKEN,
    appName: import.meta.env.VITE_TMA_ANALYTICS_IDENTIFIER,
  });
}

const bootstrap = async () => {
  const isMobilePlatform = checkMobilePlatform();

  if (isMobilePlatform) {
    const { rootWatcher } = await import('./mobile/bootstrap');

    sagaManager.run('app', rootWatcher);
  } else {
    const { rootWatcher } = await import('./other/bootstrap');

    sagaManager.run('app', rootWatcher);
  }

  performance.mark(Perf.enums.MarkName.APP_INIT_START);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      store.dispatch(System.events.domContentLoaded());
    });

    return;
  }

  store.dispatch(System.commands.init());
};

function checkMobilePlatform() {
  if (import.meta.env.DEV) {
    return true;
  }

  /** @todo вынести в отдельный инстурмент */
  const isDebugMode = Assert.isNotNull(localStorage.getItem('dddbbbggg'));

  if (isDebugMode) {
    return true;
  }

  try {
    const { tgWebAppPlatform: platform } = retrieveLaunchParams();

    return TelegramKit.Platform.isMobilePlatform.fromPlatform(platform);
  } catch {
    return false;
  }
}

void bootstrap().catch((reason: unknown) => {
  if (import.meta.env.DEV) {
    console.error(reason);
  }

  if (import.meta.env.PROD) {
    Sentry.captureException(reason);
  }
});
